import { createContext } from "../utils/createContext.mjs";
const [injectMotion, provideMotion] = createContext("Motion");
const [injectLayoutGroup, provideLayoutGroup] = createContext("LayoutGroup");
export {
  injectLayoutGroup,
  injectMotion,
  provideLayoutGroup,
  provideMotion
};
